import React from 'react';
import { Route, Switch } from 'react-router-dom';
import mockMenu from '../../mockdata/menu.json';
import mockPages from '../../mockdata/pages.json';
import PublicRoute from '../_PublicRoute';
import ArticlePage from '../ArticlePage';
import ArticlesPage from '../ArticlesPage';
import CalendarPage from '../CalendarPage';
import CategoryPage from '../CategoryPage';
import CookieDeclarationPage from '../CookieDeclarationPage';
import HomePage from '../HomePage';
import InfoPage from '../InfoPage';
import NewSearchPage from '../NewSearchPage';
import NotFoundPage from '../NotFoundPage';
import OfferPage from '../OfferPage';

/**
 * Dynamically selects and renders the appropriate page component based on the menu name.
 *
 * @param {string} pageName - Name of the page to render.
 * @param {Array} categories - Categories associated with the page (if any).
 * @param {Object} props - Props passed to the page component.
 * @returns {JSX.Element} - The selected page component.
 */
const selectPage = (pageName, categories, props) => {
  if (pageName === 'suchportal') {
    return <NewSearchPage {...props} />;
  }
  if (pageName === 'angebote') {
    return (
      <ArticlesPage menuName={pageName} buttonTextKey="offersPage.moreOffers" />
    );
  }
  if (pageName === 'gesundekommune') {
    return (
      <ArticlesPage
        menuName={pageName}
        buttonTextKey="healthyCommunityPage.moreHealthyCommunity"
      />
    );
  }
  if (pageName === 'bildung') {
    return (
      <ArticlesPage
        menuName={pageName}
        buttonTextKey="educationPage.moreEducation"
      />
    );
  }
  if (pageName === 'goodnews') {
    return (
      <ArticlesPage
        menuName={pageName}
        buttonTextKey="goodNewsPage.moreGoodNews"
        initialCount={9}
      />
    );
  }
  if (pageName === 'projekte') {
    return (
      <ArticlesPage
        menuName={pageName}
        buttonTextKey="projectsPage.moreProjects"
      />
    );
  }
  if (pageName === 'wissen') {
    return (
      <ArticlesPage
        menuName={pageName}
        buttonTextKey="knowledgePage.moreKnowledge"
      />
    );
  }
  return (
    <CategoryPage {...props} menuName={pageName} categories={categories} />
  );
};

/**
 * Routes Component
 * Defines the application's routing logic, dynamically rendering pages based on the URL.
 */
const Routes = () => {
  return (
    <Switch>
      {/* Home Page Route */}
      <PublicRoute
        exact
        home_style={2}
        parentClass="theme-3 theme3_bg"
        path="/"
        component={HomePage}
      />

      {/* Routes for mock menu items */}
      {mockMenu.map((item) => (
        <PublicRoute
          key={item.id}
          exact
          path={item.link}
          home_style={2}
          parentClass="theme-3 theme3_bg"
          component={(props) =>
            selectPage(item.pageName, item.categories, props)
          }
        />
      ))}

      {/* Routes for mock pages */}
      {mockPages.map((item) => (
        <PublicRoute
          key={item.id}
          exact
          path={item.link}
          home_style={2}
          parentClass="theme-3 theme3_bg"
          component={(props) => (
            <InfoPage {...props} name={item.name} nameKey={item.nameKey} />
          )}
        />
      ))}

      {/* Article Page Route */}
      <PublicRoute
        exact
        path="/article/:slug"
        home_style={2}
        parentClass="theme-3 theme3_bg"
        component={ArticlePage}
      />

      {/* Offer Page Route */}
      <PublicRoute
        exact
        path="/offer/:slug"
        home_style={2}
        parentClass="theme-3 theme3_bg"
        component={OfferPage}
      />

      {/* Search Portal Page Route */}
      <PublicRoute
        exact
        path="/searchportal"
        home_style={2}
        parentClass="theme-3 theme3_bg"
        component={(props) => <NewSearchPage {...props} />}
      />

      {/* Cookie Declaration Page Route */}
      <PublicRoute
        exact
        path="/cookie-declaration"
        parentClass="theme-3 theme3_bg"
        component={CookieDeclarationPage}
      />

      {/* Calendar Page Route */}
      <PublicRoute
        exact
        path="/calendar"
        parentClass="theme-3 theme3_bg"
        component={CalendarPage}
      />

      {/* Catch-All Route for Not Found Page */}
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

export default Routes;
